import styled from "styled-components"

export const Main = styled.div`
  height: 190px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 799px) {
    height: 250px;
  }
`

export const Wrapper = styled.div`
  width: 83.3%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  input {
    width: 320px;
    padding: 20px;

    @media (max-width: 799px) {
      width: 100%;
    }
  }

  @media (max-width: 1149px) {
    width: 82.5%;
  }

  @media (max-width: 799px) {
    flex-direction: column;
    width: 88.88%;
    justify-content: center;
    align-items: flex-start;
  }

  h2 {
    font-weight: 700;
    font-size: 2.3rem;
    line-height: 3.45rem;
    letter-spacing: 0.06em;
    background: linear-gradient(180deg, #ce9638 0%, #eae69c 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`

export const RightSideBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  @media (max-width: 799px) {
    height: auto;
    width: 100%;
    margin-top: 40px;
  }
`

export const Select = styled.select`
  height: 60px;
  width: 320px;

  @media (max-width: 799px) {
    width: 100%;
  }
`
